import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAclStore = create(
  persist(
    set => ({
      role: "",
      permissions: [],
      setRole: role => set({ role }),
      setPermissions: permissions => set({ permissions })
    }),
    { name: "acl" }
  )
);
